import { controls } from "./controls";

const data_entry_parents = (var_name) => [{ name: var_name, match: "exist", show: true, reverse: true }, { name: "customer_display", match: "exist", show: true }];


const trnsummary = (tab = '') => [
  ...controls.displayText({ tab: "general", label: "Total Credits", width: "col-sm-1" }),
  ...controls.showData({ tab: "general", data: "total_credit", name: "total_credit", displaytype: "currency", width: "col-sm-2", style: { backgroundColor: "#e8ffff" } }),

  ...controls.displayText({ tab: "general", label: "Total Debits", width: "col-sm-1" }),
  ...controls.showData({ tab: "general", data: "total_debit", displaytype: "currency", name: "total_debit", width: "col-sm-2", style: { backgroundColor: "#f1d4d4" } }),

  ...controls.displayText({ tab: "general", label: "Difference", width: "col-sm-1" }),
  ...controls.showData({ tab: "general", style: { backgroundColor: "#82ccdd" }, displaytype: "currency", data: "final_amount", name: "final_amount", width: "col-sm-2" }),
  ...controls.displayText({ tab: "general", label: "Batch No", width: "col-sm-1" }),
  ...controls.showData({ tab: "general", data: "batch_no", name: "batch_no", width: "col-sm-1" }),
  ...controls.showData({ tab: "general", data: "session_date", name: "session_date", width: "col-sm-1" }),
  ...controls.hr({ tab: "general", width: "col-sm-12" }),
]



const flattenedFootersHead = (tab = '') => [
  ...controls.showData({ tab, displaytype: "capital", fixed: "description", width: "col-sm-6", style: { backgroundColor: "black", color: "white", marginBottom: 10 } }),
  ...controls.showData({ tab, displaytype: "capital", fixed: "compliance", width: "col-sm-2", style: { backgroundColor: "black", color: "white" } }),
  ...controls.showData({ tab, displaytype: "capital", fixed: "remarks", width: "col-sm-4", style: { backgroundColor: "black", color: "white" } }),
]







const denominationtrn = (inputs = {}) => {
  let { reverse } = inputs;
  const currencies = [
    { denomination: "Rs. 2000 ", value: 2000, name: "rs_2000_note" },
    { denomination: "Rs. 500 ", value: 500, name: "rs_500_note" },
    { denomination: "Rs. 200 ", value: 200, name: "rs_200_note" },
    { denomination: "Rs. 100 ", value: 100, name: "rs_100_note" },
    { denomination: "Rs. 50 ", value: 50, name: "rs_50_note" },
    { denomination: "Rs. 20 ", value: 20, name: "rs_20_note" },
    { denomination: "Rs. 10 ", value: 10, name: "rs_10_note" },
    { denomination: "Rs. 5 ", value: 5, name: "rs_5_note" },
    { denomination: "Rs. 2 ", value: 2, name: "rs_2_note" },
    { denomination: "Rs. 1 ", value: 1, name: "rs_1_note" },

    { denomination: "Rs. 10 COIN", value: 10, name: "rs_10_coin" },
    { denomination: "Rs. 5 COIN", value: 5, name: "rs_5_coin" },
    { denomination: "Rs. 2 COIN", value: 2, name: "rs_2_coin" },
    { denomination: "Rs. 1 COIN", value: 1, name: "rs_1_coin" },

    { denomination: "PAISE 50 COIN", value: 0.5, name: "paise_50_coin" },
    { denomination: "PAISE 25 COIN", value: 0.25, name: "paise_25_coin" },
    { denomination: "PAISE 20 COIN", value: 0.2, name: "paise_20_coin" },
    { denomination: "PAISE 10 COIN", value: 0.1, name: "paise_10_coin" },
    { denomination: "PAISE 5 COIN", value: 0.05, name: "paise_5_coin" },
    { denomination: "PAISE 2 COIN", value: 0.02, name: "paise_2_coin" },
    { denomination: "PAISE 1 COIN", value: 0.01, name: "paise_1_coin" },

  ];

  let creditnames = [];
  let debitnames = [];


  let creditac = [];
  currencies.map(({ denomination, value, name }, idx) => {
    creditac = creditac.concat(controls.denominationrow({ sr: idx + 1, denomination, value, name: "credit_denomination." + name }));
    creditnames.push("credit_denomination." + name + "_display");
  })

  let debitac = [];
  currencies.map(({ denomination, value, name }, idx) => {
    debitac = debitac.concat(controls.denominationrow({ sr: idx + 1, denomination, value, name: "debit_denomination." + name }));
    debitnames.push("debit_denomination." + name + "_display");
  }
  )

  let creditdeno = {
    widths: "col-sm-6",
    tab: "denomination",
    style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
    subComponents: [
      {
        widths: "col-sm-12",
        tab: "general",
        title: "Credit Denomination",
        style: { borderColor: "#1eae98" },
        subComponents: [
          ...controls.displayText({ label: "Sr", width: "col-sm-1", style: { fontWeight: "bold" } }),
          ...controls.displayText({ label: "Denomination", width: "col-sm-4", style: { fontWeight: "bold" } }),
          ...controls.displayText({ label: "Quantity", width: "col-sm-3", style: { fontWeight: "bold" } }),
          ...controls.displayText({ label: "Total", width: "col-sm-4", style: { fontWeight: "bold" } }),
          ...controls.hr({ tab: "general", width: "col-sm-12" }),
          ...creditac
        ]
      }
    ]
  }
  let debitdeno = {
    widths: "col-sm-6",
    tab: "denomination",
    style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
    subComponents: [
      {
        widths: "col-sm-12",
        tab: "general",
        title: "Debit Denomination",
        style: { borderColor: "#f55c47" },
        subComponents: [
          ...controls.displayText({ label: "Sr", width: "col-sm-1", style: { fontWeight: "bold" } }),
          ...controls.displayText({ label: "Denomination", width: "col-sm-4", style: { fontWeight: "bold" } }),
          ...controls.displayText({ label: "Quantity", width: "col-sm-3", style: { fontWeight: "bold" } }),
          ...controls.displayText({ label: "Total", width: "col-sm-4", style: { fontWeight: "bold" } }),
          ...controls.hr({ tab: "general", width: "col-sm-12" }),
          ...debitac
        ]
      }
    ]
  }

  let allrows = [
    ...controls.displayText({ label: "Total Credit", tab: "denomination", width: "col-sm-2", style: { fontWeight: "bold" } }),
    ...controls.showData({ tab: "denomination", displaytype: "currency", width: "col-sm-2", style: { backgroundColor: "#e8ffff" }, formula: [{ action: "sum", datavars: creditnames }, { action: "setvar", name: "credit_denomination.total" }] }),

    ...controls.displayText({ label: "Total Debit", tab: "denomination", width: "col-sm-2", style: { fontWeight: "bold" } }),
    ...controls.showData({ tab: "denomination", displaytype: "currency", width: "col-sm-2", style: { backgroundColor: "#f1d4d4" }, formula: [{ action: "sum", datavars: debitnames }, { action: "setvar", name: "debit_denomination.total" }] }),

    ...controls.displayText({ label: "Denomination Total", tab: "denomination", width: "col-sm-2", style: { fontWeight: "bold" } }),
    ...controls.showData({ tab: "denomination", displaytype: "currency", width: "col-sm-2", style: { backgroundColor: "#82ccdd" }, formula: [{ action: "sum", datavars: ["credit_denomination.total", { name: "debit_denomination.total", mult: -1 }] }, { action: "setvar", name: "denomination.total" }] })]
  if (reverse) {
    allrows.push(debitdeno);
    allrows.push(creditdeno);
  } else {
    allrows.push(creditdeno);
    allrows.push(debitdeno);
  }
  return allrows
}

const pacsdataentry = (tab = '') => ({
  widths: "col-sm-5",
  tab,
  style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
  direction: 'vertical',
  pagination: { perPage: 30, buttonSize: 'col-sm-2' },
  subComponents: [
    {
      widths: "col-sm-12",
      tab,
      title: "Customer Information",
      style: { paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          style: {
            maxHeight: 550, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
          },
          subComponents: [


            // ...controls.displayText({ tab: "general", width: "col-sm-3", label: "Full Name", star: false }),
            // ...controls.showData({ tab: "general", width: "col-sm-9", displaytype: "capital", data: "customer_display" }),


            ...controls.magicDateLabel({ tab, width: "col-sm-5", label: "Disbursement Date", target: "disbursement_date" }),
            ...controls.magicDate({ tab, width: "col-sm-7", placeholder: "Date", name: "disbursement_date", dateType: "ontype" }),


            ...controls.checkBox({ tab, label: "Is Inherited?", name: "is_inherited", width: "col-sm-6" }),
            ...controls.checkBox({ tab, label: "Is Restructured?", name: "is_restructured", width: "col-sm-6" }),


            ...controls.magicDateLabel({
              tab, width: "col-sm-5", label: "Restructure Date", target: "restructure_date", parents: [
                {
                  name: "is_restructured",
                  match: "exist",
                }
              ]
            }),
            ...controls.magicDate({
              tab, width: "col-sm-7", placeholder: "Date", name: "restructure_date", dateType: "ontype", parents: [
                {
                  name: "is_restructured",
                  match: "exist",
                }
              ]
            }),

            ...controls.displayText({
              tab: "filter", label: "Deceased",
              parents: [
                {
                  name: "is_inherited",
                  match: "exist",
                }
              ], width: "col-sm-4"
            }),
            ...controls.oc({
              tab: "filter", c: "Customer", placeHolder: "Customer Code", name: "deceased_customer_code", fastpath: "customers",
              parents: [
                {
                  name: "is_inherited",
                  match: "exist",
                }
              ], width: "col-sm-4",
              displayData: {
                customer_display: "deceased_customer_display", customer_uid: "deceased_customer_uid", customer_code: "deceased_customer_code"
              }
            }),
            ...controls.showData({
              tab: "filter", displaytype: "capital", data: "deceased_customer_display",
              parents: [
                {
                  name: "is_inherited",
                  match: "exist",
                }
              ], width: "col-sm-4"
            }),


            ...controls.displayText({ tab, width: "col-sm-3", label: "PACS ID" }),
            ...controls.oc({ tab, width: "col-sm-4", c: "Society", placeHolder: "", name: "society_code", maxlength: 18, fastpath: "societies" }),
            ...controls.showData({ tab: "general", width: "col-sm-5", displaytype: "capital", data: "society_display" }),


            ...controls.displayText({ tab: "general", width: "col-sm-3", label: "Crop", star: false }),
            ...controls.oc({ tab: "general", width: "col-sm-4", c: "Crop", placeHolder: "Crop Code", name: "crop_code", isRequired: false, fastpath: "crops" }),
            ...controls.showData({ tab: "general", width: "col-sm-5", displaytype: "capital", data: "crop_display" }),



            ...controls.displayText({ tab, width: "col-sm-3", label: "Religion" }),
            ...controls.oc({ tab, width: "col-sm-4", c: "Religion", placeHolder: "", name: "religion_code", maxlength: 18, fastpath: "religions" }),
            ...controls.showData({ tab: "general", width: "col-sm-5", displaytype: "capital", data: "religion_display" }),



            ...controls.displayText({ tab, width: "col-sm-3", label: "Caste" }),
            ...controls.oc({ tab, width: "col-sm-4", c: "Caste", placeHolder: "", name: "caste_code", maxlength: 18, fastpath: "castes" }),
            ...controls.showData({ tab: "general", width: "col-sm-5", displaytype: "capital", data: "caste_display" }),


            ...controls.displayText({ tab, width: "col-sm-3", label: "Gender" }),
            ...controls.oc({ tab, width: "col-sm-4", c: "Gender", placeHolder: "", name: "gender_code", maxlength: 18, fastpath: "genders" }),
            ...controls.showData({ tab: "general", width: "col-sm-5", displaytype: "capital", data: "gender_display" }),


            ...controls.displayText({ tab, width: "col-sm-4", label: "Mothers Name" }),
            ...controls.text({ tab, width: "col-sm-4", placeHolder: "", name: "mothers_name", maxlength: 18 }),
            ...controls.showData({ tab, width: "col-sm-4", displaytype: "capital", data: "mothers_name_customer" }),


            ...controls.displayText({ tab, width: "col-sm-4", label: "AADHAAR" }),
            ...controls.aadharNumber({ tab, width: "col-sm-4", placeHolder: "", name: "aadhaar", maxlength: 18 }),
            ...controls.showData({ tab, width: "col-sm-4", displaytype: "capital", data: "aadhaar_customer" }),


            ...controls.displayText({ tab, width: "col-sm-4", label: "PAN" }),
            ...controls.panNumber({ tab, width: "col-sm-4", placeHolder: "", name: "pan", maxlength: 18 }),
            ...controls.showData({ tab, width: "col-sm-4", displaytype: "capital", data: "pan_customer" }),


            ...controls.displayText({ tab, width: "col-sm-4", label: "Mobile" }),
            ...controls.mobileNumber({ tab, width: "col-sm-4", placeHolder: "", name: "mobile", maxlength: 18 }),
            ...controls.showData({ tab, width: "col-sm-4", displaytype: "capital", data: "mobile_customer" }),

            ...controls.magicDateLabel({ tab, width: "col-sm-4", label: "DOB", target: "DOB" }),
            ...controls.magicDate({ tab, width: "col-sm-4", name: "dob", dateType: "ontype" }),
            ...controls.showData({ tab, width: "col-sm-4", displaytype: "capital", data: "dob_customer" }),

            ...controls.displayText({ tab, width: "col-sm-2", label: "Hector" }),
            ...controls.numberOnly({ tab, width: "col-sm-4", name: "hector" }),
            ...controls.displayText({ tab, width: "col-sm-2", label: "Aar" }),
            ...controls.numberOnly({ tab, width: "col-sm-4", name: "aar" }),


            ...controls.displayText({ tab: "general", width: "col-sm-3", label: "Overdue Prin" }),
            ...controls.floatOnly({ tab: "general", width: "col-sm-3", placeHolder: "", name: "overdue_principal", maxlength: 18 }),
            ...controls.displayText({ tab: "general", width: "col-sm-3", label: "Overdue Int" }),
            ...controls.floatOnly({ tab: "general", width: "col-sm-3", placeHolder: "", name: "overdue_interest", maxlength: 18 }),

            ...controls.magicDateLabel({ tab, width: "col-sm-5", label: "NPA Date", target: "npa_date" }),
            ...controls.magicDate({ tab, width: "col-sm-7", name: "npa_date", dateType: "ontype" }),

            ...controls.displayText({ tab, width: "col-sm-5", label: "Bal on NPA Date" }),
            ...controls.numberOnly({ tab, width: "col-sm-7", name: "balance_on_npa_date" }),




            ...controls.displayText({ tab, width: "col-sm-5", label: "Member ID" }),
            ...controls.text({ tab, width: "col-sm-7", placeHolder: "", name: "memberid", maxlength: 18 }),



            ...controls.displayText({ style: { textAlign: 'right' }, label: "Balance", width: "col-sm-5" }),
            ...controls.showData({ data: "balance", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Opening Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "account_opening_date", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Customer Type", width: "col-sm-5" }),
            ...controls.showData({ data: "custtype", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Risk Category", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "decode", params: { decode: 'riskcat' }, data: "RiskCategory", name: "RiskCategory", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Due Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "kycduedate", name: "kycduedate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Done", width: "col-sm-5" }),
            ...controls.showData({ data: "kycdone", displaytype: "yesno", width: "col-sm-7" }),
          ]
        },
      ]
    }
  ]
});




const acinfo = (tab = '') => ({
  widths: "col-sm-3",
  tab,
  style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
  direction: 'vertical',
  pagination: { perPage: 30, buttonSize: 'col-sm-2' },
  subComponents: [
    {
      widths: "col-sm-12",
      tab,
      title: "Alerts",
      style: { paddingLeft: 0, marginTop: -5, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          style: {
            maxHeight: 150, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
          },
          subComponents: [
            ...controls.displayText({ style: { color: "#b8e994" }, name: "currentpagename", width: "col-sm-12" }),
          ]
        }
      ]
    },
    {
      widths: "col-sm-12",
      tab,
      title: "Account Information",
      style: { paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          style: {
            maxHeight: 450, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
          },
          subComponents: [
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Prin Balance", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "principal_balance", name: "principal_balance", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Prin-Interest", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "principalized_interest", name: "principalized_interest", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "interest_pending", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Charges", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "charges_pending", name: "charges_pending", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Penal Int", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "penal_pending", name: "penal_pending", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Total Balance", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "balance", name: "balance", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Shadow Amt", width: "col-sm-5" }),
            ...controls.showData({ displaytype: 'currency', data: "withdrawable", width: "col-sm-7" }),




            ...controls.displayText({ style: { textAlign: 'right' }, label: "Min Balance", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", name: "min_balance", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Opening Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "account_opening_date", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Expiry Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "expdate", width: "col-sm-7" }),




            ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "intdate", name: "intdate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "FD Amount", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "fd_amount", name: "fd_amount", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Maturity amt", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "maturity_amount", name: "maturity_amount", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest Rate", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "percent", data: "int_rate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Close Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "closedate", name: "closedate", width: "col-sm-7" }),




            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cust No", width: "col-sm-5" }),
            ...controls.showData({ data: "customer_number", name: "customer_number", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Customer Type", width: "col-sm-5" }),
            ...controls.showData({ data: "customer_type", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Risk Category", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "decode", params: { decode: 'riskcat' }, data: "RiskCategory", name: "RiskCategory", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Aadhaar", width: "col-sm-5" }),
            ...controls.showData({ data: "aadhaar", name: "aadhaar", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "PAN", width: "col-sm-5" }),
            ...controls.showData({ data: "pan", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Mobile", width: "col-sm-5" }),
            ...controls.showData({ data: "mobile", name: "mobile", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Due Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "kycduedate", name: "kycduedate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Done", width: "col-sm-5" }),
            ...controls.showData({ data: "kycdone", displaytype: "yesno", width: "col-sm-7" }),

            // ]
          ]
        },
      ]
    }
  ]
});




const grouping = (tag = '') => [
  ...controls.checkBox({ tab: "filter", label: "Grouping", name: "isGrouping", width: "col-sm-12", tag }),
  {
    widths: "col-sm-12",
    tab: "filter",
    tag,
    style: { border: 0, paddingLeft: 10, marginBottom: 0 },
    subComponents: [

      ...controls.checkBox({
        tab: "filter", label: "Geographically", name: "isGeoGroup", width: "col-sm-7", parents: [
          {
            name: "isGrouping",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.displayText({
        tab: 'filter', width: "col-sm-5", label: " ", parents: [
          {
            name: "isGeoGroup",
            match: "in",
            value: [true],
            reverse: true
          }
        ], tag
      }),
      ...controls.select({
        tab: "filter", name: "geogroup", width: "col-sm-5", defaultValue: "",
        options: [{
          label: "Branch",
          value: "branch"
        },
        {
          label: "Region",
          value: "region"
        },
        {
          label: "Taluka",
          value: "taluka"
        },
        {
          label: "Zone",
          value: "zone"
        },
        {
          label: "District",
          value: "dictrict"
        }
        ],
        parents: [
          {
            name: "isGeoGroup",
            match: "in",
            value: [true],
          }
        ], tag
      }),


      ...controls.checkBox({
        tab: "filter", label: "Personal Info", name: "isPersonal", width: "col-sm-7", parents: [
          {
            name: "isGrouping",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.displayText({
        tab: 'filter', width: "col-sm-5", label: " ", parents: [
          {
            name: "isPersonal",
            match: "in",
            value: [true],
            reverse: true
          }
        ], tag
      }),
      ...controls.select({
        tab: "filter", name: "personal", width: "col-sm-5", defaultValue: "",
        options: [{
          label: "Gender",
          value: "branch"
        },
        {
          label: "Caste",
          value: "region"
        },
        {
          label: "Religion",
          value: "taluka"
        },
        {
          label: "Risk Category",
          value: "zone"
        },
        {
          label: "Section",
          value: "dictrict"
        }
        ],
        parents: [
          {
            name: "isPersonal",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.checkBox({
        tab: "filter", label: "Loan Info", name: "isLoanInfo", width: "col-sm-7", parents: [
          {
            name: "isGrouping",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.displayText({
        tab: 'filter', width: "col-sm-5", label: " ", parents: [
          {
            name: "isLoanInfo",
            match: "in",
            value: [true],
            reverse: true
          }
        ], tag
      }),
      ...controls.select({
        tab: "filter", name: "personal", width: "col-sm-5", defaultValue: "",
        options: [{
          label: "Priority",
          value: "branch"
        },
        {
          label: "Purpose",
          value: "region"
        }
        ],
        parents: [
          {
            name: "isLoanInfo",
            match: "in",
            value: [true],
          }
        ], tag
      }),
    ]
  },
  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })

]

const separation = (tag = '') => [
  ...controls.checkBox({ tab: "filter", label: "Balance Separation", name: "isBalSeparate", width: "col-sm-12", tag }),

  {
    widths: "col-sm-12",
    tab: "filter",
    tag,
    // title: "Other Details 1",
    style: { border: 0, paddingLeft: 10, marginBottom: 0 },
    subComponents: [
      ...controls.checkBox({
        tab: "filter", label: "Clearing Balance", name: "isClrSeparate", width: "col-sm-12", parents: [
          {
            name: "isBalSeparate",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.checkBox({
        tab: "filter", label: "Cash Balance", name: "isCashSeparate", width: "col-sm-12", parents: [
          {
            name: "isBalSeparate",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.checkBox({
        tab: "filter", label: "Transfer Balance", name: "isTrfSeparate", width: "col-sm-12", parents: [
          {
            name: "isBalSeparate",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.checkBox({
        tab: "filter", label: "Remittance Balance", name: "isRemitSeparate", width: "col-sm-12", parents: [
          {
            name: "isBalSeparate",
            match: "in",
            value: [true],
          }
        ], tag
      }),
    ]
  },



  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
]



// const gl = (tag = '') => [
//   ...controls.checkBox({ tab: "filter", label: "GL Separation", name: "isGLSeparate", width: "col-sm-12", tag }),

//   ...controls.checkBox({
//     tab: "filter", label: "Zero bal GL", name: "isZeroBalGL", width: "col-sm-4", parents: [
//       {
//         name: "isGLSeparate",
//         match: "in",
//         value: [true],
//       }
//     ], tag
//   }),
//   ...controls.checkBox({
//     tab: "filter", label: "Small Ac", name: "isSmallAc", width: "col-sm-4", parents: [
//       {
//         name: "isAccountSeparate",
//         match: "in",
//         value: [true],
//       }
//     ], tag
//   }),
//   ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
// ]




const accounts = (tag = '') => [
  ...controls.checkBox({ tab: "filter", label: "Separate Accounts", name: "isAccountSeparate", width: "col-sm-12", tag }),

  ...controls.checkBox({
    tab: "filter", label: "Zero bal a/c", name: "isZeroBalAc", width: "col-sm-4", parents: [
      {
        name: "isAccountSeparate",
        match: "in",
        value: [true],
      }
    ], tag
  }),
  ...controls.checkBox({
    tab: "filter", label: "Small Ac", name: "isSmallAc", width: "col-sm-4", parents: [
      {
        name: "isAccountSeparate",
        match: "in",
        value: [true],
      }
    ], tag
  }),
  ...controls.checkBox({
    tab: "filter", label: "Regular Ac", name: "isRegularAc", width: "col-sm-4", parents: [
      {
        name: "isAccountSeparate",
        match: "in",
        value: [true],
      }
    ], tag
  }),
  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
]



const getFromDB = (tag = '') => [

  // ...controls.checkBox({
  //   tab: "filter", onLeave: { action: "selectList", target: "esListOptions", label: "_source.pageData.as_on_date", value: "_id" }, label: "OLD Reports", name: "isFromES", width: "col-sm-12", tag, sendToServer: { sendData: [], dataType: "ESList" }, requiredKey: "hits"
  // }),
  // ...controls.select({
  //   tab: "filter", name: "fromESID", width: "col-sm-12", defaultValue: "",
  //   options: "esListOptions",
  //   onLeave: { action: "populate", track: 'esid', source: '_source.pageData', target: "pageData" },
  //   parents: [
  //     {
  //       name: "isFromES",
  //       match: "in",
  //       value: [true],
  //     }
  //   ], tag
  // }),

  // ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag }),

  ...controls.button({
    tab: 'filter',
    label: "FAST >>",
    style: { padding: 0 },
    Bcolor: "success",
    tag,
    onclick: {
      action: "getLastCachedReport"
    },
  }),


  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
]

const iterative = (tag = '') => [
  ...controls.checkBox({ tab: "filter", label: "Iterative Generation", name: "isIterative", width: "col-sm-12", tag }),

  {
    widths: "col-sm-12",
    tab: "filter",
    tag,
    // title: "Other Details 1",
    style: { border: 0, paddingLeft: 10, marginBottom: 0 },
    subComponents: [

      ...controls.displayText({
        tab: "filter", width: "col-sm-3", label: "Iterations", parents: [
          {
            name: "isIterative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.text({
        tab: "filter", name: "iterIterations", placeHolder: "Iterations", width: "col-sm-9", parents: [
          {
            name: "isIterative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.displayText({
        tab: 'fitler', width: "col-sm-3", label: "Frequency",
        parents: [
          {
            name: "isIterative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.radio({
        width: "col-sm-9",
        // style:{paddingLeft:50},
        name: "iterationSchedule", cwidth: "col-sm-12", options: [{ label: "Daily", value: "daily" }, { label: "Weekly", value: "Weekly" }, { label: "Last Friday", value: "lastFriday" }, { label: "Fortnightly", value: "fortnightly" }, { label: "Monthly", value: "Monthly" }, { label: "Quarterly", value: "quarterly" }, { label: "Half Yearly", value: "halfyearly" }, { label: "Yearly", value: "yearly" }], parents: [
          {
            name: "isIterative",
            match: "in",
            value: [true],
          }
        ], tag
      }),
    ]
  },
  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
]


const bulk = (tag = '') => [
  ...controls.checkBox({ tab: "filter", label: "Bulk", name: "isBulk", width: "col-sm-12", tag }),

  {
    widths: "col-sm-12",
    tab: "filter",
    tag,
    // title: "Other Details 1",
    style: { border: 0, paddingLeft: 10, marginBottom: 0 },
    subComponents: [

      ...controls.displayText({
        tab: "general", width: "col-sm-12", label: "Bulk Code", parents: [
          {
            name: "isBulk",
            match: "in",
            value: [true],
          }
        ]
      }),
      ...controls.oc({
        tab: "general", c: "BulkReport", width: "col-sm-12", placeHolder: "Bulk Report Code", name: "bulk_report_code", fastpath: "bulk_reports", parents: [
          {
            name: "isBulk",
            match: "in",
            value: [true],
          }
        ]
      }),
      ...controls.showData({
        tab: "general", displaytype: "capital", width: "col-sm-12", data: "bulk_report_display", parents: [
          {
            name: "isBulk",
            match: "in",
            value: [true],
          }
        ]
      }),

    ]
  },
  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
]


const comparative = (tag = '') => [
  ...controls.checkBox({ tab: "filter", label: "Comparative", name: "isComparative", width: "col-sm-12", tag }),

  {
    widths: "col-sm-12",
    tab: "filter",
    tag,
    // title: "Other Details 1",
    style: { border: 0, paddingLeft: 10, marginBottom: 0 },
    subComponents: [
      ...controls.magicDateLabel({
        tab: "filter", label: "Start Date", width: "col-sm-3", parents: [
          {
            name: "isComparative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.magicDate({
        tab: "filter", name: "compareStartDate", width: "col-sm-9", parents: [
          {
            name: "isComparative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.displayText({
        tab: "filter", width: "col-sm-3", label: "Iterations", parents: [
          {
            name: "isComparative",
            match: "in",
            value: [true],
          }
        ], tag
      }),
      ...controls.text({
        tab: "filter", name: "compIterations", placeHolder: "Iterations (Max 4)", width: "col-sm-9", parents: [
          {
            name: "isComparative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.displayText({
        tab: 'fitler', width: "col-sm-3", label: "Frequency",
        parents: [
          {
            name: "isComparative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

      ...controls.radio({
        width: "col-sm-9",
        // style:{paddingLeft:50},
        name: "comparativeSchedule", cwidth: "col-sm-12", options: [{ label: "Daily", value: "daily" }, { label: "Weekly", value: "Weekly" }, { label: "Last Friday", value: "lastFriday" }, { label: "Fortnightly", value: "fortnightly" }, { label: "Monthly", value: "Monthly" }, { label: "Quarterly", value: "quarterly" }, { label: "Half Yearly", value: "halfyearly" }, { label: "Yearly", value: "yearly" }], parents: [
          {
            name: "isComparative",
            match: "in",
            value: [true],
          }
        ], tag
      }),

    ]
  },
  ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag })
]





const customerinfo = (tab = '') => ({
  widths: "col-sm-3",
  tab,
  style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
  direction: 'vertical',
  pagination: { perPage: 30, buttonSize: 'col-sm-2' },
  subComponents: [
    {
      widths: "col-sm-12",
      tab,
      title: "Alerts",
      style: { paddingLeft: 0, marginTop: -5, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          style: {
            maxHeight: 400, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
          },
          subComponents: [
            ...controls.displayText({ style: { color: "#b8e994" }, name: "currentpagename", width: "col-sm-12" }),
          ]
        }
      ]
    },
    {
      widths: "col-sm-12",
      tab,
      title: "Customer Information",
      style: { paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          style: {
            maxHeight: 350, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
          },
          subComponents: [
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Full Name", width: "col-sm-5" }),
            ...controls.showData({ data: "full_name", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Mothers Name", width: "col-sm-5" }),
            ...controls.showData({ data: "mothers_name", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Gender", width: "col-sm-5" }),
            ...controls.showData({ data: "gender", name: "gender", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Religion", width: "col-sm-5" }),
            ...controls.showData({ data: "religion", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Caste", width: "col-sm-5" }),
            ...controls.showData({ data: "caste", width: "col-sm-7" }),



            ...controls.displayText({ style: { textAlign: 'right' }, label: "AADHAAR", width: "col-sm-5" }),
            ...controls.showData({ data: "aadhaar", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "PAN", width: "col-sm-5" }),
            ...controls.showData({ data: "pan", width: "col-sm-7" }),



            ...controls.displayText({ style: { textAlign: 'right' }, label: "Mobile", width: "col-sm-5" }),
            ...controls.showData({ data: "mobile", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Balance", width: "col-sm-5" }),
            ...controls.showData({ data: "balance", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "interest_debited", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "FD Amount", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "fd_amount", name: "fd_amount", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "aadhar", width: "col-sm-5" }),
            ...controls.showData({ data: "aadhar", name: "aadhar", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Maturity amt", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "maturity_amount", name: "maturity_amount", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Total", width: "col-sm-5" }),
            ...controls.showData({ style: { backgroundColor: "#b8e994" }, displaytype: "currency", more: "total_explanation", data: "total", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Opening Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "account_opening_date", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Exp Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "expdate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Close Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "closedate", name: "closedate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "intdate", name: "intdate", width: "col-sm-7" }),


            ...controls.displayText({ style: { textAlign: 'right' }, label: "Customer Type", width: "col-sm-5" }),
            ...controls.showData({ data: "custtype", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Risk Category", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "decode", params: { decode: 'riskcat' }, data: "RiskCategory", name: "RiskCategory", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Due Date", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "date", data: "kycduedate", name: "kycduedate", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Done", width: "col-sm-5" }),
            ...controls.showData({ data: "kycdone", displaytype: "yesno", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Pay Day", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "cashpaymentday", name: "cashpaymentday", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Day", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", name: "cashreceiptday", data: "cashreceiptday", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Pay Week", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "cashpaymentweek", name: "cashpaymentweek", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Week", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "cashreceiptweek", name: "cashreceiptweek", width: "col-sm-7" }),


            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Qtr", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "qtrreceipts", name: "qtrreceipts", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Pay Qtr", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "qtrpayments", name: "qtrpayments", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "Cash Pay Year", name: "Cash Pay Year", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Year", width: "col-sm-5" }),
            ...controls.showData({ displaytype: "currency", data: "cashreceiptyear", name: "cashreceiptyear", width: "col-sm-7" }),

            ...controls.displayText({ style: { textAlign: 'right' }, label: "Open By", width: "col-sm-5" }),
            ...controls.showData({ data: "openbyuser", name: "openbyuser", width: "col-sm-7" }),
            // ]
          ]
        },
      ]
    }
  ]
});
const leaveInformation = (tab = '') => ({
  widths: "col-sm-4",
  tab,
  style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
  direction: 'vertical',
  pagination: { perPage: 30, buttonSize: 'col-sm-2' },
  subComponents: [
    {
      widths: "col-sm-12",
      tab,
      title: "Leave Balances",
      style: { paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          style: {
            maxHeight: 400, border: 0, overflow: "scroll", paddingRight: 0
          },
          subComponents: [
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Privilege", width: "col-sm-5" }),
            ...controls.showData({ data: "privilege", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Casual", width: "col-sm-5" }),
            ...controls.showData({ data: "casual", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Medical", width: "col-sm-5" }),
            ...controls.showData({ data: "medical", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Maternity", width: "col-sm-5" }),
            ...controls.showData({ data: "maternity", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Marriage Leave ", width: "col-sm-5" }),
            ...controls.showData({ data: "marriage_leave", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Paternity Leave ", width: "col-sm-5" }),
            ...controls.showData({ data: "paternity_leave", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            ...controls.displayText({ style: { textAlign: 'right' }, label: "Without pay ", width: "col-sm-5" }),
            ...controls.showData({ data: "without_pay", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),
            // ]
          ]
        },
      ]
    }
  ]
});


export {
  grouping,
  separation,
  comparative,
  accounts,
  getFromDB,
  iterative,
  acinfo,
  pacsdataentry,
  trnsummary,
  denominationtrn,
  bulk,
  customerinfo,
  leaveInformation,
  flattenedFootersHead
}

